import request, { get, post, sendReq, sendReqH5, lowCodePost } from "@/utils/request";
import Qs from 'qs'

// 获取首页信息
export function getShowHomeColumnLists(pageObj) {
    return get("/business-api/mobile-home/getShowHomeColumnLists", pageObj);
}

// 获取附件列表
export function getImg(pageObj) {
    return get("/business-api/mobile-home/getImg", pageObj);
}

// 政策公告查询
export async function getPolicyNews(pageObj) {
    return await lowCodePost("/processApi/form/formCustSql/view/list_noticeList",pageObj);
}


// 权限验证接口
export const tokenH5 = async (token) => {
    const res = await sendReqH5({
        url: '/business-api/jypxsz/getToken',
        method: 'GET',
        params: {token: token},
        headers: {
            'content-type': 'application/x-www-form-urlencoded' // 默认值
        }
    })
    return res
}

// 字典值
export const getDictTypeByNameValues = async (typeId) => {
    const res = await sendReq({
        url: '/business-api/mobile-user-info/getDictType',
        method: 'GET',
        params: {
            typeId: typeId,
        },
        headers: {
            'content-type': 'application/x-www-form-urlencoded' // 默认值
        }
    })
    return res
}


// 获取附件列表
export async function viewFile(bizId,bizType) {
    return await sendReq({
        url: "/uploadApi/filePreview/fildListByBizType",
        method: 'GET',
        params: {bizId: bizId, bizType: bizType},
        type: 'androidToken',
        headers: {
            "content-type": "application/x-www-form-urlencoded"
        }
    });
}

// 附件删除
export function deleteFile(pageObj) {
    return get("/uploadApi/upload/deleteFile", pageObj);
}
//附件保存
export async function saveFile(params) {
    return await sendReq({
        url: '/uploadApi/upload/saveFile',
        method: 'POST',
        data: params,
        headers: {
            "content-Type": "multipart/form-data"
        },
    });
}


export function getFormParams(params,pageNo,pageSize){
    let paramsMap=new Map()
    paramsMap["curPage"] = pageNo;
    paramsMap["pageSize"] = pageSize;
    paramsMap["params"] = params != null ? getFormParamsInfo(params) : "{}";
    return JSON.stringify(paramsMap);
}
function getFormParamsInfo(params){
    let paramsMap =new Map();
    let queryData = [];

    for(var key in params){
        let map = new Map();
        map['name'] = key;
        map['con'] = '=';
        map['val'] = params[key];
        queryData.push(map);
    }
    paramsMap["queryData"] = queryData;
    return JSON.stringify(paramsMap);
}